import React, { useState } from 'react'
import ItemImage from '../ItemImage'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import styled from 'styled-components'

const DirContainer = styled.div`
    display: inline-block;
    cursor: pointer;
    margin: 0px 5px;
    width: 33px;
`

const ImgContainer = styled.div`
    height: 50px;
    width: 50px;
    margin-left: 10px; 
    cursor: pointer;
    display: inline-block;
`

export default function Thumbs(props) {
    const { grouped, setGroupedKey, groupedKey } = props;
    const [startIdx, setStartIdx] = useState(0)

    const thumbs = Object.keys(grouped).map((key, i) => {
        return (
            <ImgContainer {...{
                onClick: () => setGroupedKey(key),
                key,
                style: {
                    outline: groupedKey === key ? '1px solid rgb(219, 22, 51)' : '1px solid #aaa',
                }
            }}>
                <ItemImage {...{
                    details: { itemMedia: grouped[key] },
                    size: 'thumbnail',
                }} />
            </ImgContainer>
        )
    })

    const displayThumbs = thumbs.slice(startIdx, startIdx + 3);

    return (
        <div>
            <DirContainer>
                {startIdx > 0 && (
                    <div onClick={() => setStartIdx(startIdx - 1)}>
                        <ChevronLeft fontSize='large' sx={{ color: 'rgb(219, 22, 51)' }} />
                    </div>
                )}
            </DirContainer>
            {displayThumbs}
            <DirContainer>
                {
                    thumbs.length > startIdx + 3 && (
                        <div onClick={() => setStartIdx(startIdx + 1)}>
                            <ChevronRight fontSize='large' sx={{ color: 'rgb(219, 22, 51)' }} />
                        </div>
                    )
                }
            </DirContainer>
        </div>
    )
}